<template>
  <v-row v-if="show" class="mt-1">
    <v-col class="pa-0 pr-5" align="right">
      <v-chip :color="havePermissions ? 'primary' : 'orange'" label style="margin-top: -10px">
        <v-icon class="mr-1" small>mdi-account-circle-outline</v-icon>
        {{ userLabel }}
        <span class="ml-2" v-if="!havePermissions">{{ $t('settings.errors.missingPermissions') }}</span>
        <span class="ml-2" v-if="havePermissions && readOnly">{{ $t('perms.readOnly') }}</span>
      </v-chip>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'settings-user-badge',
  props: {
    havePermissions: { type: Boolean, default: false },
    readOnly: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters({
      isOwnerCurUser: 'settings/isOwnerCurUser',
      ownerID: 'settings/ownerID',
      ownerUser: 'settings/activeSubAccount',
      subAccounts: 'settings/subAccounts'
    }),
    show: function () {
      return !this.isOwnerCurUser && this.ownerUser
    },
    userLabel: function () {
      return `${this.ownerUser?.name} <${this.ownerUser?.username}>`
    }
  }
}
</script>

<style scoped>
</style>
